module.exports = __webpack_public_path__ + "static/img/10.4ed83a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10.jpg
// module id = wCKK
// module chunks = 1